// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.DataSourceSaveAction
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSEnum.vm
// If you need to 'extend' the enum, create another file with module of the same name and add functions to it...

export let DataSourceSaveAction = /*#__PURE__*/function (DataSourceSaveAction) {
  DataSourceSaveAction[DataSourceSaveAction["ADD"] = 0] = "ADD";
  DataSourceSaveAction[DataSourceSaveAction["CHANGE"] = 1] = "CHANGE";
  DataSourceSaveAction[DataSourceSaveAction["DELETE"] = 2] = "DELETE";
  DataSourceSaveAction[DataSourceSaveAction["RE_ADD"] = 3] = "RE_ADD";
  return DataSourceSaveAction;
}({});
(function (_DataSourceSaveAction) {
  function fromJson(enumVal) {
    // Canonically always return numeric representation of enum (NOT a string!)
    // An enumVal of either string or number will return undefined if invalid (out of range)
    return typeof enumVal === "number"
    // For safety, check for number in range, if not return undefined
    ? DataSourceSaveAction[enumVal] != null ? enumVal : undefined : DataSourceSaveAction[enumVal];
  }
  _DataSourceSaveAction.fromJson = fromJson;
  function name(enumIndex) {
    return this[enumIndex];
  }
  _DataSourceSaveAction.name = name;
  function indexOf(enumVal) {
    return enumVal; // Erasure....
  }
  _DataSourceSaveAction.indexOf = indexOf;
})(DataSourceSaveAction || (DataSourceSaveAction = {}));
//# sourceMappingURL=DataSourceSaveAction.js.map
